export var sliderIds = new WeakMap();
export function getSliderThumbId(state, index) {
  var id = sliderIds.get(state);

  if (!id) {
    throw new Error('Unknown slider state');
  }

  return "".concat(id, "-").concat(index);
}